<p *ngIf="title">{{title}}</p>
<form>
  <div class="form-group">
    <app-timezone-select-menu
      [timezones]="timezones"
      [selectedZone]="selectedZone"
      (onSelect)="onTimezoneSelect($event)"
      [classes]="'custom-select'"></app-timezone-select-menu>
  </div>
  <button type="button" class="btn btn-primary" (click)="onContinueBtnClick()">Let's Go!</button>
</form>
